import { cloneDeep } from 'lodash';
import { ColumnConfiguration as ColumnConfigurationV2 } from '../models/configurableTable';
import { AnyAbility } from '@casl/ability';
import { ColumnConfiguration } from '../../Sim/Inventory/constants/columnConfigurationsConstants';

export const reorderColumns = (
  columns: ColumnConfiguration[],
  oldIndex: number,
  targetIndex: number,
) => {
  const newColumnsOrder = cloneDeep(columns);
  const srcColumn = newColumnsOrder[oldIndex];

  newColumnsOrder.splice(oldIndex, 1);
  newColumnsOrder.splice(targetIndex, 0, srcColumn);

  return newColumnsOrder.map((column, index) => ({
    ...column,
    position: index + 1,
  }));
};

export function compareByPosition(a: ColumnConfiguration, b: ColumnConfiguration) {
  return a.position - b.position;
}

export const canColumnBeDisplayed = (
  column: ColumnConfigurationV2,
  { ability }: { ability: AnyAbility },
) => {
  return !column.permission || ability.can(column.permission.action, column.permission.subject);
};

export const getOnlyColumnsToDisplayed = (
  configuration: ColumnConfigurationV2[],
  { ability }: { ability: AnyAbility },
) => {
  return configuration.filter((column) => canColumnBeDisplayed(column, { ability }));
};
